import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ATTACHMENTS_URL } from "./_requests";
import { LoadingDialog } from "../controls";
import { Backdrop, Box, Fade, Modal, Typography } from "@material-ui/core";

const style = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "300px",
  backgroundColor: "white",
  borderRadius: 4,
  gap: "20px",
};

export function NewAttachmentButton({ model, recordId, onNewFile }) {
  const { authToken } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const fileInputRef = useRef();

  const allowedFileTypes = [
    "image/jpeg", // Images
    "image/jpg",
    "image/png",
    "image/gif",
    "video/mp4", // Videos
    "application/pdf", // PDF
    "audio/wav", // Audio
    "audio/ogg",
    "audio/mpeg",
  ];

  const uploadFile = () => {
    const file = fileInputRef.current.files[0];

    if (!file) {
      handleOpen();
      return;
    }

    // Validate file type from 'allowedFileTypes'
    if (!allowedFileTypes.includes(file.type)) {
      handleOpen();
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("formFile", file);
    formData.append("recordId", recordId);
    formData.append("model", model);

    const xhr = new XMLHttpRequest();
    xhr.addEventListener("load", SuccessHandler, false);
    xhr.open("POST", ATTACHMENTS_URL);
    xhr.setRequestHeader("Authorization", "Bearer " + authToken);

    xhr.send(formData);
  };

  function SuccessHandler() {
    setLoading(false);
    onNewFile();
  }

  // trigger modal
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotprops={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box
            className={"d-flex flex-column position-absolute p-4"}
            sx={style}
          >
            <Box className={"d-flex justify-content-end"}>
              <button
                type="button"
                className={"border-0 bg-transparent p-0"}
                onClick={handleClose}
              >
                <SVG
                  style={{ width: 45 }}
                  src={toAbsoluteUrl("/media/svg/icons/Files/Close.svg")}
                />
              </button>
            </Box>
            <Typography variant="h6" className={"text-center"}>
              فرمت فایل آپلود شده مجاز نمی باشد لطفا فایل دیگری انتخاب کنید
            </Typography>
          </Box>
        </Fade>
      </Modal>

      {loading && (
        <div
          className={
            "position-fixed top-0 left-0 w-100 d-flex justify-content-center align-items-center"
          }
          style={{
            height: "100dvh",
            backgroundColor: "white",
            opacity: 0.6,
            zIndex: 9999,
          }}
        >
          <span className="mr-10 spinner spinner-primary"></span>
          <span>لطفا تا اتمام آپلود منتظر بمانید ...</span>
        </div>
      )}
      <div
        style={{ minWidth: 50, minHeight: 50 }}
        className={
          "cursor-pointer p-2 rounded-lg bg-secondary bg-hover-primary-o-1 ml-3 d-flex align-items-center justify-content-center"
        }
      >
        <input
          ref={fileInputRef}
          onChange={uploadFile}
          type={"file"}
          className={"d-none"}
        />
        <SVG
          onClick={() => fileInputRef.current.click()}
          src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
        />
      </div>
    </>
  );
}
